// const ID = process.env.NEXT_PUBLIC_CLIENT_UID;
import {memo} from "react";

const PATH = process.env.PUBLIC_URL

function Icon(
	{name, children, className, ...props}
) {

	return (
		<svg className={`svg-icon ${className || ''}`} {...props}>
			<use href={`${PATH}/icons/sprite.svg?id=#${name}`} />
		</svg>
	);
}

export default memo(Icon);